<template>
  <div class="icons">
    <transition-group
      class="icons-list"
      :style="{
        color: config.color,
        '--num': config.num,
        gridGap: `${config.gap.vertical}px ${config.gap.horizontal}px`,
      }"
      name="horizontal"
      tag="ul"
    >
      <li
        class="icon-item"
        v-for="icon in config.list"
        :key="icon.key"
        :style="{
          ...itemStyle,
          '--horizontal': config.gap.horizontal + 'px',
        }"
      >
        <img
          class="icon-img"
          :class="[icon.icon, `size-${config.size}`]"
          :style="{ color: icon.color }"
          :src="icon.img"
          v-if="icon.img"
        />
        <div class="icon-title" :style="{ color: icon.textColor }">
          {{ icon.title }}
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { getDistance } from "../../common/js/tool";

export default {
  name: "icons",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    width() {
      let num = this.config.num;
      return 100 / num + "%";
    },
    itemStyle() {
      let item = this.config.item;
      let style = {};
      if (item.padding) {
        style.padding = getDistance(item.padding);
      }
      if (item.borderRadius) {
        style.borderRadius = item.borderRadius + "px";
      }
      if (item.backgroundColor) {
        style.backgroundColor = item.backgroundColor;
      }
      return style;
    },
  },
};
</script>

<style scoped lang="less">
.icons {
  --main-color: #004098;
  --text-font-color: #606266;
}
.icons-list {
  font-size: 0;
  color: var(--main-color);
  display: grid;
  grid-template-columns: repeat(var(--num), 1fr);
}
.icon-item {
  display: inline-block;
  transition: all 0.3s;
  text-align: center;
}

.icon-img {
  color: var(--main-color);
  &.size-1 {
    // --icon-font-size: 20px;
    width: 20px;
    height: 20px;
  }
  &.size-2 {
    // --icon-font-size: 30px;
    width: 30px;
    height: 30px;
  }
  &.size-3 {
    // --icon-font-size: 40px;
    width: 40px;
    height: 40px;
  }
  margin: 0 auto;
  width: var(--icon-font-size);
  height: var(--icon-font-size);
  font-size: var(--icon-font-size);
  object-fit: fill;
  img {
    width: 100%;
    vertical-align: baseline;
    object-fit: fill;
  }
}
.icon-title {
  margin-top: 6px;
  font-size: 14px;
  color: var(--text-font-color);
}
</style>
